module.exports = __webpack_public_path__ + "img/battery.25e4bb68.svg";